import { React, useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Table, Button, Container, Stack, Spinner } from 'react-bootstrap';
import { IoMdAdd } from "react-icons/io";
import { TbClockCog } from "react-icons/tb";
import { MdEdit } from "react-icons/md";
import { FaTools } from 'react-icons/fa';
import { useUserContext } from 'contexts/UserContext';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import * as api from 'services/api';
import BlockTimesModal from './BlockTimesModal';
import InterventionTypeModal from './InterventionTypeModal';
import EditOverridecodeModal from './EditOverridecodeModal';
import { useTranslation } from 'react-i18next';
export function ControlCentreConfig() {
    const { t } = useTranslation();
    let { centreid } = useParams();
    const navigate = useNavigate();
    const { userData } = useUserContext();
    const { controlCentre, updateControlCentre } = useControlCentreContext();
    const timeModalRef = useRef(null);
    const editModalRef = useRef(null);
    const interventionTypeModalRef = useRef(null);
    //#region ------------------- STATES ---------------
    const [loading, setLoading] = useState(true);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showTimeModal, setShowTimeModal] = useState(false);
    const [showInterventionTypeModal, setShowInterventionTypeModal] = useState(false);
    const [editModal, setEditModal] = useState({});
    const [intervetionTypeModal, setInterventionTypeModal] = useState({});
    const [timeModal, setTimeModal] = useState({
        configid: '',
        pseudoid: '',
        timeset: []
    });
    const [controlCentreConfigs, setControlCentreConfigs] = useState([]);
    const [error, setError] = useState('');

    //#endregion

    //#region ------------------- EFFECTS --------------

    const fetchData = async () => {
        try {
            const response = await api.getControlCentreConfigs(centreid);
            if (response.status === 200) {
                setControlCentreConfigs(response.data);
            } else {
                setError('Error al recuperar el  centro de control...');
            }


        } catch (error) {
            console.error('Error fetching centros de control:', error);
            setError('No se pudieron recuperar los datos.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    //#endregion

    //#region ------------------- HANDLERS -------------

    const setEditModalConfig = (config) => {
        setEditModal(config);
    };

    const handleModalClose = () => {
        fetchData();
    };

    const handleManagePseudocodes = (centreid) => {
        if (userData && userData.role === 'Admin') {
            updateControlCentre({ ...controlCentre, origin: null });
            navigate(`/pseudocodesManagement/${centreid}`);
        }
    };
    const handleShowTimeModal = (show, config) => {
        setTimeModal({
            configid: config.controlCentreConfigId,
            pseudoid: config.pseudoCodeId,
            timeset: config.blockingTimeSet
        });
        setShowTimeModal(show);
    };
    const handleShowInterventionTypeModal = (show, config) => {
        setShowInterventionTypeModal(show);
        setInterventionTypeModal(config);
    };
    const handleShowEditModal = (show, config) => {
        setEditModalConfig(config);
        setShowEditModal(show);
    };

    //#endregion

    return (
        <Container fluid className="px-5 mt-5" style={{ maxWidth: '1280px' }}>
            <div className='text-end'>
                <Link to={'/controlCentresPanel'}><Button variant="outline-secondary">{t('ccControlCentreList')}</Button></Link>
            </div>
            <h2 className='mb-5'>{controlCentre.centrename}</h2>
            <Stack direction="horizontal" className="justify-content-start">
                {error && <p className="text-danger fw-semibold">{error}</p>}
            </Stack>
            <div className="card rounded-3 overflow-auto p-2">
                <table className="table table-hover overflow-auto">
                    <thead>
                        <tr>
                            <th colSpan={3} className="text-center bg-dark text-white">{t('ccPseudoCodeOrigin')}</th>
                            <th colSpan={3} className="text-center bg-danger text-white">{t('ccPseudoCodeDestination')}</th>
                            <th colSpan={4} className="text-center bg-light">&nbsp;</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr style={{ fontSize: '15px' }}>
                            <th className="text-center bg-light">{t('Id')}</th>
                            <th className="text-center bg-light">{t('ccPseudoCode')}</th>
                            <th className="text-center bg-light">{t('ccPseudoCodeText')}</th>
                            <th className="text-center bg-light">{t('Id')}</th>
                            <th className="text-center bg-light">{t('ccOverride')}</th>
                            <th className="text-center bg-light">{t('ccOverrideText')}</th>
                            <th className="text-center bg-light">{t('ccInterventionType')}</th>
                            <th className="text-center bg-light" colSpan='3'>&nbsp;</th>
                        </tr>
                    </thead>

                    {controlCentreConfigs.length > 0 && (
                        <tbody>
                            {controlCentreConfigs.map((config, i) => (
                                <tr key={i}>
                                    <td className="text-center">{config.pseudoCodeId}</td>
                                    <td className="text-center">{config.pseudoCode}</td>
                                    <td className="text-center">{config.pseudoCodeText}</td>
                                    <td className="text-center">{config.overrideCodeId}</td>
                                    <td className="text-center">{config.overrideCode}</td>
                                    <td className="text-center">{config.overrideCodeText}</td>
                                    <td className="text-center">{config.interventionName}</td>
                                    <td><Button variant="dark" className='px-2' onClick={() => handleShowEditModal(true, config)}><MdEdit /></Button></td>
                                    <td><Button variant="dark" className='px-2' onClick={() => handleShowTimeModal(true, config)}><TbClockCog /></Button></td>
                                    <td><Button variant="dark" className='px-2' onClick={() => handleShowInterventionTypeModal(true, config)}><FaTools /></Button></td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                    <EditOverridecodeModal ref={editModalRef}
                        show={showEditModal}
                        setShow={setShowEditModal}
                        state={editModal}
                        onClose={handleModalClose}
                    />
                    <BlockTimesModal ref={timeModalRef}
                        show={showTimeModal}
                        setShow={setShowTimeModal}
                        state={timeModal}
                        onClose={handleModalClose}
                    />
                    <InterventionTypeModal ref={interventionTypeModalRef}
                        show={showInterventionTypeModal}
                        setShow={setShowInterventionTypeModal}
                        state={intervetionTypeModal}
                        onClose={handleModalClose}
                    />
                    {loading && (<tbody>
                        <tr>
                            <td><Spinner animation="border" variant="secondary" size="sm" /></td>
                        </tr>
                    </tbody>)}

                </table>
            </div>
            <div className='d-flex flex-row justify-content-between mt-5'>
                <Button variant="primary" className='p-0' onClick={() => handleManagePseudocodes(centreid)}><IoMdAdd style={{ fontSize: '2rem', padding: 2 }} /></Button>
            </div>
        </Container>
    );
}